export function mapImageUrl(imageURL) {
    if(!imageURL.includes('http')) return imageURL
    return imageURL
}


// WEBPACK FOOTER //
// ./src/utils/mapImageUrl.js